import {useEffect, useState} from "react"
import '../singleLayer/SingleLayerTitle.css'
import {Breadcrumb} from "antd";
import {getLayerBreadcrumb} from "../singleLayer/singleLayerService";

export function SplitViewLayerTitle({idOne, idTwo}) {
    const [breadcrumbDataOne, setBreadcrumbDataOne] = useState([{'title': '...'}]);
    const [breadcrumbDataTwo, setBreadcrumbDataTwo] = useState([{'title': '...'}]);

    useEffect(() => {

        idOne && getLayerBreadcrumb(idOne).then((response) => {
            setBreadcrumbDataOne(response.data);
        })

        idTwo && getLayerBreadcrumb(idTwo).then((response) => {
            setBreadcrumbDataTwo(response.data);
        })

    }, [idOne, idTwo]);

    return (
        <div className="mapTitle">
            <div className="mapTitleSplitView">
                <div className="mapTitleBox">
                    <Breadcrumb
                        separator=""
                        items={breadcrumbDataOne}
                    />
                </div>
            </div>
            <div className="mapTitleSplitViewSpacer"></div>
            <div className="mapTitleSplitView">
                <div className="mapTitleBox">
                    <Breadcrumb
                        separator=""
                        items={breadcrumbDataTwo}
                    />
                </div>
            </div>
        </div>
    )
}